import o from "./core/storyblok-component.mjs";
import { createRichTextHook as t } from "./core/richtext-hoc.mjs";
const i = t(o, {
  isServerContext: !1
});
export {
  i as useStoryblokRichText
};
